
import { Form, FormElement, FormRenderProps } from "@progress/kendo-react-form"
import { handleInputChange } from "../../functions/inputFunctions/inputFunctions"
import Input from "../kendo/input"
import InputPassword from "../kendo/password"
import { apiPost } from "../../api/apiPost"
import { ValidButton } from "../buttons/validButton"
import { useConf } from "../../context/account/paramsAccount"
import { saveCredentials, saveModeHorsligne } from "../../functions/localStorage/saveLocalStorage"
import { useError } from "../../context/erreur/erreurContext"
import { useOfflineMode } from "../../context/horsLigne/modeHorsLigneContext"
import { useEffect, } from "react"
import { hashPassword } from "../../functions/crypt/hashPassword"
import ImageApp from "../../images/mobichef.svg"
import { loadCredentials } from "../../functions/localStorage/recupStorage"
import { Storage } from "@capacitor/storage";
import { apiMobiChef } from "../../api/apiMobichef"
const checkUUIDOnLoad = async (showError: any, setConf: any, conf: any, ifOffLineMode: any) => {
    const params = new URLSearchParams(window.location.search);
    const uuid = params.get('uuid');
    function isValidUUID(uuid: string) {
        const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
        return uuidRegex.test(uuid);
    }

    if (uuid && isValidUUID(uuid)) {
        const response = await apiMobiChef("/posts/mobiWinDev", { uuid: uuid }, showError);
        if (response && response.authenticated) {
            const credentials = await loadCredentials(response.authenticated.u_code);
            if (credentials) {
                setConf((prev: any) => ({
                    ...prev,
                    ...credentials,
                    token: response.token,
                    password: "",

                    user: {
                        ...prev.user,
                        ...response.authenticated.u_code,
                        password: "",
                        isConnected: true,
                    },
                }));
                await saveCredentials({
                    ...conf,
                    user: {
                        ...response.authenticated.u_code,
                        password: "",
                        isConnected: true,
                    },
                    token: response.token,
                    conf: {
                        authenticated: {
                            access_ok: response.authenticated.acces_ok,
                            u_nom: response.authenticated.u_code
                        },
                        ...ifOffLineMode, ifOffLineMode: ifOffLineMode
                    }
                },
                    conf,
                    setConf,
                    response.authenticated.u_code
                );
            } else {
                setConf((prevConf: any) => ({
                    ...prevConf,
                    user: {
                        ...response.authenticated.u_code,
                        password: "",
                        isConnected: true,
                    },
                    token: response.token,
                    conf: {
                        authenticated: {
                            access_ok: response.authenticated.acces_ok,
                            u_nom: response.authenticated.u_code
                        },
                        ...ifOffLineMode, ifOffLineMode: ifOffLineMode
                    }
                }))

                await saveCredentials({
                    ...conf,
                    user: {
                        ...response.authenticated.u_code,
                        password: "",
                        isConnected: true,
                    },
                    token: response.token,
                    conf: {
                        authenticated: {
                            access_ok: response.authenticated.acces_ok,
                            u_nom: response.authenticated.u_code
                        },
                        ...ifOffLineMode, ifOffLineMode: ifOffLineMode
                    }
                },
                    conf,
                    setConf,
                    response.authenticated.u_code
                );
            }
            await Storage.set({ key: 'active_user', value: response.authenticated.u_code.user_code });

        }
        return response
    } else {
        console.error("Paramètre non valide :");
    }
};
export function FormulaireConnexionUser() {
    const { conf, setConf } = useConf()
    const { showError } = useError();

    const { ifOffLineMode, toggleOfflineMode } = useOfflineMode();
    useEffect(() => {
        checkUUIDOnLoad(showError, setConf, conf, ifOffLineMode);
    }, []);

    // useEffect(() => {
    //     // setConf((prevConf: any) => ({
    //     //     ...prevConf,
    //     //     user: {
    //     //         ...conf.user,
    //     //         id: generatedguid,
    //     //         subscriber: 'PROGIAL_86',
    //     //         codeApplication: 'mobi-chef',
    //     //         codeModule: 'defaut',
    //     //         typeConnexion: 'A'
    //     //     }
    //     // }))
    // }, [])
    function removePasswords(obj: any) {
        if (typeof obj !== "object" || obj === null) return obj;

        for (const key of Object.keys(obj)) {
            if (key.toLowerCase().includes("password")) {
                obj[key] = "";
            } else if (typeof obj[key] === "object") {
                removePasswords(obj[key]);
            }
        }
        return obj;
    }
    const ConnectApp = async (user: any) => {
        const userDataConnect = {
            user_code: user.user_code,
            password: user.password,
            subscriber: user.subscriber,
            codeApplication: 'mobi-chef',
            codeModule: 'defaut',
            typeConnexion: 'A'
        }
        const { site, ...userWithoutSite } = user
        savePassword()
        try {
            const response = await apiPost('/posts/user-login', userDataConnect, showError);
            const credentials = await loadCredentials(user);
            if (response?.authenticated?.connexion_ok === true) {
                if (credentials) {
                    setConf((prev) => ({
                        ...prev,
                        ...credentials,
                        password: "",
                        token: response.token,
                        user: {
                            ...prev.user,
                            ...user,
                            password: "",
                            isConnected: true,
                        },
                    }));
                    await saveCredentials({
                        ...conf,
                        user: {
                            ...user,
                            password: "",
                            isConnected: true,
                        },
                        token: response.token,
                        conf: {
                            authenticated: {
                                access_ok: response.authenticated.acces_ok,
                                u_nom: response.authenticated.u_nom
                            },
                            ...ifOffLineMode, ifOffLineMode: ifOffLineMode
                        }
                    },
                        conf,
                        setConf,
                        conf.user.user_code
                    );
                } else {
                    setConf((prevConf) => ({
                        ...prevConf,
                        user: {
                            ...user,
                            password: "",
                            isConnected: true,
                        },
                        token: response.token,
                        conf: {
                            authenticated: {
                                access_ok: response.authenticated.acces_ok,
                                u_nom: response.authenticated.u_nom
                            },
                            ...ifOffLineMode, ifOffLineMode: ifOffLineMode
                        }
                    }))

                    await saveCredentials({
                        ...conf,
                        user: {
                            ...user,
                            password: "",
                            isConnected: true,
                        },
                        token: response.token,
                        conf: {
                            authenticated: {
                                access_ok: response.authenticated.acces_ok,
                                u_nom: response.authenticated.u_nom
                            },
                            ...ifOffLineMode, ifOffLineMode: ifOffLineMode
                        }
                    },
                        conf,
                        setConf,
                        conf.user.user_code
                    );
                }
                await Storage.set({ key: 'active_user', value: user.user_code });

            } else {
                setConf((prevConf) => ({
                    ...prevConf,
                    user: { ...user, isConnected: false },
                }))

            }
        } catch (error) {
            console.error('Error during connection:', error);
            setConf((prevConf) => ({
                ...prevConf,
                user: { ...user, isConnected: false },
            }))
        }
    };
    const savePassword = async () => {
        try {
            const passwordHashed = await hashPassword(conf?.user?.password);
            return saveModeHorsligne(passwordHashed, 'localPassword', conf);

        } catch (error) {
            console.error('Erreur lors du hachage du mot de passe:', error);
        }
    };
    return (
        <div>
            <Form
                render={(formRenderProps: FormRenderProps) => (
                    <FormElement className="connexionforms">
                        <img src={`${ImageApp}`} alt="logo mobi-chef" className="logoMobiChef"></img>
                        <Input name={"Souscripteur"} onChange={(value: any) => { handleInputChange('subscriber', setConf, conf.user, value) }} value={conf?.user.subscriber}></Input>
                        <Input name={"Utilisateur"} onChange={(value: any) => { handleInputChange('user_code', setConf, conf.user, value) }} value={conf?.user.user_code}></Input>
                        <InputPassword name={"Mot de passe"} onChange={(value: any) => { handleInputChange('password', setConf, conf.user, value) }} value={conf?.user?.password}></InputPassword>
                        <div className="containerButton">
                            <ValidButton onClick={() => ConnectApp(conf.user)}> Connexion</ValidButton>
                        </div>
                    </FormElement>
                )}
            />

        </div>
    )
}